import { apolloClient } from '~/apollo-client';
import { ContractVersion } from '~/services/fetch-vnm-terms';
import {
  Flex_CreateContractAgreementPerchMutation,
  Flex_CreateContractAgreementPerchMutationVariables,
} from '~/typings/graphql';
import { CREATE_CONTRACT_AGREEMENT_PERCH } from './agree-to-perch-terms.queries';

export const agreeToPerchTerms = async (
  params: AgreeToPerchTerms,
): Promise<AgreeToPerchTermsResponse> => {
  const { userId, vnmSolarProjectContracts } = params;
  if (!vnmSolarProjectContracts?.length) return;

  const contractVersionIds = Array.from(
    new Set(vnmSolarProjectContracts.map(contract => contract.id)),
  );
  const input = {
    userAgent: navigator.userAgent,
    contractVersionIds,
    userId,
  };

  await apolloClient.mutate<
    Flex_CreateContractAgreementPerchMutation,
    Flex_CreateContractAgreementPerchMutationVariables
  >({
    mutation: CREATE_CONTRACT_AGREEMENT_PERCH,
    variables: { input },
  });
};

export interface AgreeToPerchTerms {
  userId: number;
  vnmSolarProjectContracts?: ContractVersion[];
}

export type AgreeToPerchTermsResponse = void;
